/**
 * @typedef {Object} Storage
 * @property {Function} set
 * @property {Function} get
 */

/**
 * @class
 * @param {Storage} storage
 */
function UserPreferences(storage) {
  this.storage = storage;

  /**
   * @typedef {object} Preferences
   * @property {boolean} listView
   * @property {boolean} showDetailOnArrival
   * @property {NotificationSound} notificationSound
   * @property {boolean} showDesktopNotifications
   * @property {boolean} notificationEnabledQueues
   */

  /**
   * @type {Preferences}
   */
  this._preferences = {
    listView: null,
    showDetailOnArrival: null,
    notificationSound: null,
    showDesktopNotifications: null,
    language: null,
    notificationEnabledQueues: []
  }

  this.preferences = function () {
    return this._preferences;
  }

  this.set = function (key, value) {
    this._preferences[key] = value;
  }

  this.get = function (key) {
    return this._preferences[key]
  }

  this.update = function(items) {
    if (items) {
      Object.assign(this._preferences, items);
    }
  }

  /**
   * Store the user preferences object to Local Storage or Cookies
   * @method store
   */
  this.store = function () {
    this.storage.set('userPrefs', JSON.stringify(this._preferences));
  };

  /**
   * Reads the the user preferences from the browser's localStorage or cookie.
   * @method load
   * @param {(preferences: object) => {}} [callback]
   */
  this.load = function (callback) {
    var preferencesJSON = this.storage.get('userPrefs');

    if (preferencesJSON) {
      var parsedPreferences = {};

      try {
        parsedPreferences = JSON.parse(preferencesJSON)
      }
      catch(e) {
        // `JSON.parse` throws SyntaxError if the JSON can't be parsed.
        parsedPreferences = {};
      }

      this.update(parsedPreferences);
    }

    // Load preferences from old storage locations
    this.migrateListViewPreference();
    this.migrateLanguagePreference();
    this.migrateTicketClassifierId();

    if (callback) {
      callback(this._preferences)
    }
  }

  this.migrateListViewPreference = function () {
    var useListView = (this.storage.get('listView') === 'true')
    if (useListView) {
      this.set("listView", true)
      this.storage.del("listView")
    }
  }

  this.migrateLanguagePreference = function () {
    var preferredLanguage = this.storage.get("preferredLanguage");
    if (preferredLanguage && preferredLanguage !== "null" && preferredLanguage !== "") {
      this.set("language", preferredLanguage)
      this.storage.del("preferredLanguage")
    }
  }

  this.migrateTicketClassifierId = function () {
    var ticketClassifierId = this.storage.get("ticketClassifierId");
    if (ticketClassifierId && ticketClassifierId !== "null" && ticketClassifierId !== "") {
      this.set("ticketClassifierId", ticketClassifierId)
      this.storage.del("ticketClassifierId")
    }
  }
}

module.exports = UserPreferences;
